import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Address.css";
import { customerAddresses } from "../../features/user/userSlice";
import { getLocations } from "../../features/locations/locationSlice";

/**
 * Component that displays the Address page
 *
 * @return {JSX.Element} Address component JSX
 */
function Address() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLocations());
  }, [dispatch]);

  const addresses = useSelector(customerAddresses);
  const address = addresses.length > 0 ? addresses[0] : {};

  return (
    <div className="address_container">
      <h5>Delivery Address</h5>
      <span>{address.name}</span>
      <span>{address.line1}</span>
      <span>{address.line2}</span>
      <span>
        {address.city} {address.state} {address.zipCode}
      </span>
    </div>
  );
}

export default Address;
